/**
 * Componente Button Corporativo
 * Botón reutilizable con colores corporativos
 */

import React from 'react';
import { Button, ButtonProps, useTheme } from '@mui/material';
import { createButtonStyles } from '../../theme/utils';

interface CorporateButtonProps extends ButtonProps {
  colorVariant?: 'primary' | 'accent' | 'accentSecondary';
}

export const CorporateButton: React.FC<CorporateButtonProps> = ({
  colorVariant = 'accent',
  sx,
  ...props
}) => {
  const theme = useTheme();
  const buttonStyles = createButtonStyles(theme, colorVariant);

  return (
    <Button
      {...props}
      sx={{
        ...buttonStyles,
        ...sx,
      }}
    />
  );
};













